import Loader from "react-loader-spinner";
import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Row, Card, Col, Table, Button } from "react-bootstrap";
import { getServiceCountReport, getServiceDeadlineReport, getServiceWatingForReceptionList, getStaffPerformance_MyServiceCostList, getStaffTotalFunctions } from "../store/api/Services";
import { getSystemSettings } from '../store/api/SystemSettingsAPI';
import { getPageFieldList } from '../store/api/Users';
import { getMyCommandsCount } from '../store/api/CommandsAPI';
import { Link } from 'react-router-dom';
import { getReminder, searchUnreadReminders } from '../../store/api/ReminderAPI';
import ModalReminder from "../../Components/Modals/ModalReminder";
import { exitDocumentFromDashboard, getDocumentReferList, getServiceReferList, setReferToRead, setReferToUnRead } from "../../store/api/Users";
import { Calendar2Check, Calendar2Date, CheckCircle, EnvelopeFill, EyeSlashFill, HouseCheck, HouseGear, Link45deg, Paperclip, Printer, Tools } from "react-bootstrap-icons";
import { useIsMobileApp } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import { faCalendarCheck, faCashRegister, faCommentAlt, faPaperPlane, faPhoneSquare, faTable, faUserClock, faWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const renderLegend = (props) => {
    const { payload } = props;
    return (
        <Fragment>
            {
                payload.map((entry, index) => (
                    <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                        <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                        &nbsp;{entry.value.replace("InstallCount", "نصب ها").replace("RepairCount", "تعمیرها").replace("Count", "تعداد")}
                    </span>
                ))
            }
        </Fragment>
    );
}
const HomePage = () => {
    const settingNames = ['ProductGrouppingType', 'NationalCodeIsRequired', 'Services_SerialObligatoryInInstall', 'Services_SerialObligatoryInRepair', "Services_ProductSerial_IsEnglish"];
    const dispatch = useDispatch();
    const history = useHistory();
    const isMobile = useIsMobileApp();
    const [popReminder, setPopReminder] = useState({ show: false });
    const [width, setWidth] = useState(window.innerWidth);
    const [serviceWatingList, getServiceWaitingList] = useState([]);
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const fieldList = useSelector(state => state.UserReducer.pageFieldList);
    const unreadReminders = useSelector(state => state.UserReducer.unreadReminders);
    const commandsCount = useSelector(state => state.CommandsReducer.myCommandsCount);
    const [documentReferList, setDocumentReferList] = useState(null);
    const [modalUnreadReminders, setModalUnreadReminders] = useState({ show: false });
    const { serviceDeadlineReport, staffTotalfunctions, myServiceCostList } = useSelector(state => {
        return {
            myServiceCostList: state.service.staffMySRVCostList, serviceDeadlineReport: state.service.serviceDeadlineReport,
            staffTotalfunctions: state.service.staffTotalfunctions
        }
    });
    const totalStaffShare = myServiceCostList?.Data?.map(s => s.StaffShare).reduce((a, b) => a + b, 0);
    const checkFieldPermission = (fieldName, actionType) => {
        let result = true;
        let field = fieldList?.find(f => f.PageName === "ServiceMainPage" && f.Name === fieldName);
        if (actionType === "Read" && field) {
            result = field.IsRead;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false
        }
        return result;
    }
    const dashboardTableButtons = [
        { type: "common", title: "تبدیل به خوانده نشده", tooltip: "تبدیل به خوانده نشده", className: "group-Btn-smalll", icon: <EyeSlashFill size={20} color="#d35512" className="rowBtn" />, onclick: setRefToUnRead, showCondition: (row) => row.IsRead },
        { type: "common", title: "انجام", tooltip: "انجام", className: "group-Btn-smalll", icon: <CheckCircle size={20} color="#008054" className="rowBtn" />, onclick: setExit }
    ]
    const dashboardTableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "PEnterDate", colTitle: "تاریخ ارجاع", showInMobile: true },
        { colName: "ReferDescription", colTitle: "شرح ارجاع", showInMobile: false },
        { colName: "PriorityStr", colTitle: "اولویت کارتابل", showInMobile: true },
        { colName: "DocumentDate", colTitle: "تاریخ سرویس" },
        { colName: "DocumentNumber", colTitle: "شماره سرویس" },
        { colName: "PDocumentType", colTitle: "نوع سرویس" },
        { colName: "Status", colTitle: "وضعیت سرویس" },
        { colName: "PServiceDeadline", colTitle: "تاریخ موعد", styleCondition: (row) => row.ServiceDeadlineColor ? { backgroundColor: row.ServiceDeadlineColor } : { backgroundColor: "unset" } },
        { colName: "ProductNameAndModel", colTitle: "کالا" },
        { colName: "CustomerName", colTitle: "مشتری" },
        {
            colName: "", colType: "calc", valueFunction: (row) =>
                <div>
                    <div className="tooltipBtn" style={{ display: "inline-block", position: "relative" }} data-tooltip="شمار پیام ها"><EnvelopeFill size={15} color="#f75f5f" />
                        <label style={{ position: "absolute", left: "-3px", bottom: "-8px", fontWeight: "bold", fontSize: "14px", color: "blue" }}>{row.ServiceInternalMessageCount} </label>
                    </div>
                    &nbsp;
                    <div className="tooltipBtn" style={{ display: "inline-block", position: "relative" }} data-tooltip="شمار رویدادها"><Calendar2Check size={15} color="#196f95" />
                        <label style={{ position: "absolute", left: "-3px", bottom: "-8px", fontWeight: "bold", fontSize: "14px", color: "blue" }}>{row.EventCount} </label>
                    </div>
                    &nbsp;
                    <div className="tooltipBtn" style={{ display: "inline-block", position: "relative" }} data-tooltip="شمار پیوست ها"><Paperclip size={15} color="#800043" />
                        <label style={{ position: "absolute", left: "-3px", bottom: "-8px", fontWeight: "bold", fontSize: "14px", color: "blue" }}>{row.AttachmentCount} </label>
                    </div>
                </div>
        }
    ]
    if (isMobile) {
        dashboardTableButtons.push({ type: "show", title: "نمایش فرم", className: "group-Btn-smalll", onclick: showRefrDoc, showCondition: () => isMobile });
    }

    function showReminder(id) {
        const onSuccess = (rem) => {
            setPopReminder({ show: true, reminder: rem });
        }
        dispatch(getReminder(id, onSuccess));
    }
    function newReminder() {
        setPopReminder({ show: true });
    }
    function setRefToUnRead(row) {
        const onSet = (res) => {
            if (res.Data) {
                getDocumentReferList("install,repair", false, false, false, setDocumentReferList);
            }
        }
        setReferToUnRead(row.ID, onSet)
    }
    function setExit(row) {
        const onExit = (res) => {
            if (res.Data) {
                getDocumentReferList("install,repair", false, false, false, setDocumentReferList);
            }

        }
        exitDocumentFromDashboard(row.ID, onExit);
    }

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    function showRefrDoc(row) {
        setReferToRead(row.ID, () => { });
        if (row.ctrlIsDown) {
            window.open(`/Services/Service/${row.DocumentID}/${row.DocumentHardCode}`);
        }
        else {
            history.push(`/Services/Service/${row.DocumentID}/${row.DocumentHardCode}`);
        }
    }
    function showService(serviceID, serviceType) {
        history.push(`/Services/Service/${serviceID}/${serviceType}`, null);
    }
    function printDeadlines(e) {
        history.push({
            pathname: `/PrintViewer/DeadlineReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetServiceDeadlineReport?staffID=0&agencyID=null`,
                method: "get"
            }
        });
    }
    useEffect(() => {
        document.body.classList = "";
        dispatch(getServiceCountReport());
        dispatch(getServiceDeadlineReport());
        dispatch(getStaffTotalFunctions());
        dispatch(getMyCommandsCount());
        getServiceWatingForReceptionList(getServiceWaitingList);
        getServiceReferList(false, false, false, setDocumentReferList);
        dispatch(getStaffPerformance_MyServiceCostList({ LastRefDateFrom: new Date(), LastRefDateTo: new Date() }));
        window.addEventListener('resize', handleWindowSizeChange);
        if (!systemSettings || systemSettings.length === 0) {
            dispatch(getSystemSettings(settingNames));
        }
        dispatch(getPageFieldList(""));
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    return (
        <div>
            <ModalReminder pop={popReminder} setPop={setPopReminder} />
            <img style={{ marginTop: "10px", marginBottom: "10px" }} alt="" />
            <div className="container-fluid mt-1">
                <Row className="g-1">
                    <Col className="mt-1" xs={4} md={2}>
                        <Card className="saleCards" style={{ "--mainColor": "#66abaf", "--footerColor": "#66abaf", padding: 0, boxShadow: "2px 2px 4px black" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">
                                    <FontAwesomeIcon icon={faPhoneSquare} size="lg" />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>
                            <Card.Body style={{ color: "blue" }}>
                                <label>
                                    {staffTotalfunctions?.HappycallGrade && staffTotalfunctions.HappycallGrade + "درصد"}
                                </label>
                            </Card.Body>
                            <Card.Footer style={{ boxShadow: "0px 0px 6px gray", color: "white" }}>رضایتمندی</Card.Footer>
                        </Card>
                    </Col>
                    <Col className="mt-1" xs={4} md={2}>
                        <Card className="saleCards" style={{ "--mainColor": "#cb5941", "--footerColor": "#cb5941", padding: 0, boxShadow: "2px 2px 4px black" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">
                                    <FontAwesomeIcon icon={faCommentAlt} size="lg" />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>
                            <Card.Body style={{ color: "blue" }}>
                                <label>
                                    {commandsCount && commandsCount !== "PENDING" && <Link to="/UserDashboard">{commandsCount}</Link>}
                                </label>
                            </Card.Body>
                            <Card.Footer style={{ color: "white", boxShadow: "0px 0px 6px gray" }}>
                                دستور کارها
                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col className="mt-1" xs={4} md={2}>
                        <Card className="saleCards" style={{ "--mainColor": "#cb4169", "--footerColor": "#cb4169", padding: 0, boxShadow: "2px 2px 4px black" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">
                                    <FontAwesomeIcon icon={faCashRegister} size="lg" />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>
                            <Card.Body style={{ color: "blue" }}>
                                {checkFieldPermission("RemainedAccount", "Read") ?
                                    <Link to="/Services/StaffAgencyAccBook">
                                        <label className="ellipsisLabel" style={{ direction: "ltr" }}>
                                            {staffTotalfunctions?.RemainedAccount?.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) ?? 0}
                                        </label>
                                    </Link> :
                                    "عدم دسترسی"
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "white", boxShadow: "0px 0px 6px gray" }}>مانده حساب</Card.Footer>
                        </Card>
                    </Col>
                    <Col className="mt-1" xs={4} md={2}>
                        <Button variant="info" style={{ height: "100%", width: "100%", boxShadow: "2px 2px 4px black" }} onClick={newReminder}>
                            <Calendar2Date size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>یادآوری جدید</span>
                        </Button>
                    </Col>
                    <Col className="mt-1" xs={4} md={2}>
                        <Button variant="secondary" style={{ height: "100%", width: "100%", boxShadow: "2px 2px 4px black" }}
                            onClick={() => history.push(`/Services/Service/0/install`, null)}>
                            <HouseCheck size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                نصب جدید
                            </span>
                        </Button>
                    </Col>
                    <Col className="mt-1" xs={4} md={2}>
                        <Button variant="warning" style={{ height: "100%", width: "100%", boxShadow: "2px 2px 4px black" }}
                            onClick={() => history.push(`/Services/Service/0/repair`, null)}>
                            <Tools size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                تعمیر جدید </span>
                        </Button>
                    </Col>
                </Row>
                <Row className="mt-2" style={{ margin: 0, padding: 0 }}>
                    <Card style={{ padding: 0 }}>
                        <Card.Header style={{ color: "black", border: "none", backgroundColor: "#934e75" }}>
                            <Card.Title style={{ color: "white" }}>
                                <FontAwesomeIcon icon={faWrench} size="lg" color="white" />
                                &nbsp;&nbsp;
                                سرویس های ارجاع شده به من
                            </Card.Title>
                        </Card.Header>
                        <Card.Body style={{ overflow: "auto", padding: "2px" }} className="scThin">
                            <BihamtaTable columns={dashboardTableCols} dataList={documentReferList} rowButtons={dashboardTableButtons} className="mt-0 mb-0 designedTable" style={{ "--rowColor": "#e2d9ff80", whiteSpace: "noWrap" }}
                                rowClick={showRefrDoc} searchable={true} maxHeight={500} />
                        </Card.Body>
                    </Card>
                </Row>
                <Row xs={1} md={3} className="g-4 mt-1">
                    <Col md={6} style={{ height: "340px" }}>
                        <Card style={{ height: "100%", background: "rgb(246 246 247)" }}>
                            <Card.Header style={{ background: "#549ed5" }}>
                                <Card.Title style={{ display: "inline-block", color: "white" }}>
                                    <FontAwesomeIcon icon={faUserClock} size="lg" />&nbsp;
                                    <Link to="/Services/StaffPerformanceTotalCost" style={{ color: "white" }}> عملکرد امروز من</Link>
                                </Card.Title>
                            </Card.Header>
                            <Card.Body style={{ overflow: "auto" }} className="scThin">
                                <Table className="designedTable" style={{ "--rowColor": "#add1d9" }}>
                                    <thead style={{ backgroundColor: "#6db7bb" }}><tr>
                                        <th>نوع</th>
                                        <th>شماره</th>
                                        <th>تاریخ پذیرش</th>
                                        <th>نوع خدمت</th>
                                        <th>شرح خدمت</th>
                                        <th>سهم تکنسین</th>
                                    </tr></thead>

                                    {Array.isArray(myServiceCostList?.Data) &&
                                        <tbody>
                                            {myServiceCostList?.Data.map((srv, i) => <tr key={i} onClick={() => showService(srv.ServiceID, srv.ServiceType.toLowerCase())}>
                                                <td>{srv.PServiceType}</td>
                                                <td>{srv.InvoiceNumber}</td>
                                                <td>{srv.PFirstContactDate}</td>
                                                <td>{srv.PRowType}</td>
                                                <td>{srv.CostDesc}</td>
                                                <td>{srv.StaffShare?.toLocaleString("en")}</td>
                                            </tr>)}
                                            <tr style={{ fontWeight: "bold" }}>
                                                <td colSpan={5} style={{ textAlign: "left", position: "sticky", bottom: 0, background: "#49abc9" }}>مجموع:</td>
                                                <td style={{ position: "sticky", bottom: 0, background: "#49abc9" }}>{totalStaffShare.toLocaleString("en")}</td>
                                            </tr>

                                        </tbody>}
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card style={{ background: "rgb(246 246 247)", color: "white", height: "340px" }}>
                            <Card.Header style={{ background: "#b35a5a" }}>
                                <Card.Title><FontAwesomeIcon icon={faCalendarCheck} size="lg" />&nbsp; ده یادآوری اخیر</Card.Title>
                            </Card.Header >
                            <Card.Body>
                                {unreadReminders === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {Array.isArray(unreadReminders?.Data ?? "") &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#fadef791" }}>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {unreadReminders.Data.map((row, i) =>
                                                    <tr key={i} onClick={() => showReminder(row.ID)}>
                                                        <td style={{ minWidth: "70px" }}>{row.PAlarmDate}</td>
                                                        <td>{row.RemBody}</td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                    {(serviceWatingList === "PENDING" || serviceWatingList?.Data) &&
                        <Col md={6}>
                            <Card style={{ background: "rgb(246 246 247)", color: "white", height: "340px" }}>
                                <Card.Header style={{ background: "#715ab3" }}>
                                    <Card.Title>
                                        <FontAwesomeIcon icon={faPaperPlane} size="lg" />&nbsp;
                                        <span className="cardTitle"> درخواست های منتظر پذیرش</span>
                                    </Card.Title>
                                    <div className="sepLine"></div>
                                </Card.Header>

                                <Card.Body>
                                    {serviceWatingList === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                    {serviceWatingList?.Data && Array.isArray(serviceWatingList?.Data) &&
                                        <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                            <Table className="designedTable" style={{ "--rowColor": "#e2d9ff80" }}>
                                                <thead style={{ backgroundColor: "#d1afea" }}>
                                                    <tr>
                                                        <th style={{ padding: "4px" }}>نوع سرویس</th>
                                                        <th style={{ padding: "4px" }}>شماره سرویس</th>
                                                        <th style={{ padding: "4px" }}>مشخصات محصول</th>
                                                        <th style={{ padding: "4px" }}>نام مشتری</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                    {serviceWatingList.Data.map((row, i) => <tr key={i} onClick={() => showService(row.ServiceID, row.ServiceType)}>
                                                        <td style={{ minWidth: "70px" }}>{row.ServiceTypePersianText}</td>
                                                        <td>{row.InvoiceNumber}</td>
                                                        <td>{row.ProductName + "-" + row.ProductModel}</td>
                                                        <td>{row.CustomerName}</td>
                                                    </tr>)}
                                                </tbody>
                                            </Table>
                                        </div>
                                    }
                                </Card.Body>

                            </Card>
                        </Col>
                    }

                </Row>
            </div>
        </div>

    )

}

export default HomePage;